/* eslint-disable tailwindcss/no-arbitrary-value */
/* eslint-disable react/forbid-prop-types */
import { Loader } from '@thd-olt-component-react/core-ui';
import _get from 'lodash/get';
import _groupBy from 'lodash/groupBy';
import _head from 'lodash/head';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _isNull from 'lodash/isNull';
import _last from 'lodash/last';
import _map from 'lodash/map';
import _pick from 'lodash/pick';
import proptypes from 'prop-types';
const { bool, func, object, oneOfType, string } = proptypes;
import React, { useEffect } from 'react';
import { NEW_RELIC_EVENTS, STACK_BUILDER } from '../../constants';
import StickyZoneCard from '../../pages/sticky-zone-card';
import ZoneCard from '../../pages/zone-card';
import {
  useConfiguratorStore,
  useDigitalDataStore,
  useMediaStore
} from '../../store';
import { useDesignStore } from '../../store/design/context';
import { _initialState as _initialDesignState } from '../../store/design/_initialState';
import '../../styles/product/visualizer.scss';
import logNewRelicCustom from '../../utils/logNewRelicCustom';
import TotalPrice from '../TotalPrice';
import { useGroupedPromotions } from '../../hooks/useGroupedPromotions';
import {
  ActionBar, DimensionsBar,
  PromoBanner,
  Callout,
  ShareContainer,
  StackModal,
  Trash
} from './components';
import EmptyStack from './components/EmptyStack';
import { SvgIcon, ZoomSvg } from './components/SvgIcon';
import StackInner from './StackInner';

export default function Visualizer({
  data, itemId, isDesktop, handleCalloutClick, displayCallout
}) {
  const mediaAssets = useMediaStore((state) => state.assets);
  const choices = useConfiguratorStore((state) => state.configurator.choices);
  const { promoEligibleItemsInDesign } = useGroupedPromotions();
  const visualizerImage = data?.data?.visualizerImage;

  if (!data.ready || _isEmpty(mediaAssets) || _isEmpty(choices)) {
    return (
      <div
        className="visualizer__root sui-overflow-hidden"
        style={{
          backgroundImage: 'url(https://blinds.homedepot.com/SqlImages/cd8b11c8-1ce7-ee11-94a4-0a986990730e.jpg)'
        }}
      >
        <div className="loading--placeholder">
          <Loader active />
        </div>
      </div>
    );
  }

  return isDesktop ? (
    <StickyZoneCard className="zone-card sticky-zone-card col__12-12">
      <div
        className="visualizer__root sui-overflow-hidden"
        style={{ backgroundImage: `url(${visualizerImage})` }}
      >
        <StackContainer
          data={data?.data}
          backgroundImage={visualizerImage}
        />
      </div>
      <div className="sui-flex total-price-desktop sui-pb-[10px] sui-h4-bold">
        <ShareContainer />
        <TotalPrice itemId={itemId} />
      </div>
      { !_isEmpty(promoEligibleItemsInDesign) && (
        <>
          <div className="sui-w-full sui-h-[10px] sui-bg-[#f5f5f5] sui-absolute sui-ml-[-10px]" />
          <div className="sui-pt-2">
            <PromoBanner />
          </div>
        </>
      )}
      {displayCallout && (
        <>
          <div className="sui-w-full sui-h-[10px] sui-bg-[#f5f5f5] sui-absolute sui-ml-[-10px]" />
          <div className="sui-pt-2">
            <Callout
              headerTitle={STACK_BUILDER.PACKOUT.CALLOUT_HEADER}
              message={STACK_BUILDER.PACKOUT.CALLOUT_BODY}
              onClick={handleCalloutClick}
              isDesktop={isDesktop}
            />
          </div>
        </>
      )}
    </StickyZoneCard>
  ) : (
    <ZoneCard className="zone-card col__12-12">
      <div
        className="visualizer__root sui-overflow-hidden"
        style={{ backgroundImage: `url(${visualizerImage})` }}
      >
        <StackContainer
          data={data?.data}
          backgroundImage={visualizerImage}
        />
      </div>
    </ZoneCard>
  );
}

Visualizer.propTypes = {
  itemId: string.isRequired,
  data: oneOfType([func, object]),
  isDesktop: bool.isRequired,
  handleCalloutClick: func.isRequired,
  displayCallout: bool.isRequired
};

Visualizer.defaultProps = {
  data: {}
};

const StackContainer = ({ data: matrix, backgroundImage }) => {
  const design = useDesignStore((state) => state.design);
  const resetSelected = useDesignStore((state) => state.resetSelected);
  const updateDesign = useDesignStore((state) => state.update);
  const metadata = useConfiguratorStore((state) => state.configurator.metadata);
  const media = useMediaStore((state) => state.assets);
  const toggleZoomModal = useDesignStore((state) => state.toggleZoomModal);
  const trackZoomModalClickEvent = useDigitalDataStore((state) => state.trackZoomModalClickEvent);

  const footer = document?.querySelector('.footer');
  const body = document.querySelector('body');

  const handleOpen = () => {
    if (!_isNull(footer)) {
      footer.style.overflow = 'hidden';
    }
    body.style.position = 'fixed';
    trackZoomModalClickEvent();
    resetSelected();
    toggleZoomModal();
    logNewRelicCustom(NEW_RELIC_EVENTS.ZOOM_OPEN, design);
  };
  const handleClose = () => {
    if (!_isNull(footer)) {
      footer.removeAttribute('style');
    }
    body.removeAttribute('style');
    toggleZoomModal();
    logNewRelicCustom(NEW_RELIC_EVENTS.ZOOM_CLOSE, design);
  };

  useEffect(() => {
    updateDesign({
      matrix: {
        rows: matrix?.rows,
        columns: matrix?.columns,
        segments: matrix?.segments
      }
    });
    return () => false;
  }, []);

  const isFromPip = design.products.length === 1 && design.isFromPip;

  const displayVisualizerComponents = () => {
    if (isFromPip) {
      return false;
    }
    if (!_isEmpty(design.products)) {
      return true;
    }
    return false;
  };

  const shouldDisplayVisualizerComponents = displayVisualizerComponents();

  return (!_isEmpty(design.matrix) && !_isEmpty(metadata) && !_isEmpty(media))
    ? (
      <div className="stack-wrapper">
        {!_isEmpty(design.products) && (
          <StackModal
            open={design.isZoomModalOpen}
            handleClose={handleClose}
            backgroundImage={backgroundImage}
          >
            <StackInner />
          </StackModal>
        )}
        <ActionBar
          hasProducts={!_isEmpty(design.products)}
          hasLineItems={!_isEmpty(design.cart)}
        />
        <StackInner />
        {(shouldDisplayVisualizerComponents) && (
          <>
            <div className="visualizer__dimensions">
              <DimensionsBar />
            </div>
            <SvgIcon
              icon={<ZoomSvg />}
              style={{
                position: 'absolute',
                top: '5.8rem',
                right: 0,
                margin: '1rem',
                padding: '0.25rem',
                height: 'auto',
                zIndex: 1,
                width: '3.2rem',
                color: 'var(--swiper-theme-color)'
              }}
              onClick={handleOpen}
            />
          </>
        )}
        {(!_isEmpty(design.products)) && (
          <Trash />
        )}
        {(_isEmpty(design.products) || (isFromPip)) && (
          <EmptyStack isFromPip={isFromPip} />
        )}
      </div>
    ) : (
      <div className="loading--placeholder">
        <Loader active />
      </div>
    );
};

StackContainer.propTypes = {
  data: object,
  backgroundImage: string,
};

StackContainer.defaultProps = {
  data: _initialDesignState,
  backgroundImage: ''
};
